import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'app-chips-column',
    templateUrl: './chips-column.component.html',
    styleUrls: ['./chips-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipsColumnComponent {
  readonly chips = input<string[]>([]);
}
